import {JsonProperty} from 'json-typescript-mapper';
import {BackofficeMarketAccountingEntry} from './backoffice-market-accounting-entry.model';
import {MarketOverviewEntry} from './market-overview-entry.model';
import {ContactSimplified} from './contact.model';
import {MarketdateMeterreading} from './marketdate-meterreading.model';
import {ElectricMeter} from './electric-meter.model';

export class MarketAccounting {
  @JsonProperty({clazz: BackofficeMarketAccountingEntry, name: 'accountings'})
  public marketAccountingEntries?: BackofficeMarketAccountingEntry[];

  @JsonProperty('date')
  public date?: string;

  @JsonProperty('electricMeterInfo')
  public electricMeterInfo?: ElectricMeter[];

  @JsonProperty('marketMasters')
  public marketMasters?: ContactSimplified[];

  @JsonProperty('marketingFee')
  public marketingFee?: number;

  @JsonProperty('municipality')
  public municipality?: string;

  @JsonProperty('place')
  public place?: string;

  @JsonProperty('placeDescription')
  public placeDescription?: string;

  @JsonProperty({clazz: MarketOverviewEntry, name: 'overview'})
  public marketOverviewEntry?: MarketOverviewEntry;

  @JsonProperty('phone')
  public phone?: number;

  @JsonProperty('title')
  public title?: string;

  @JsonProperty('branch')
  public branch?: number;

  @JsonProperty('updated')
  public updated?: string;

  constructor() {
    this.marketAccountingEntries = void 0;
    this.date = void 0;
    this.electricMeterInfo = void 0;
    this.marketMasters = void 0;
    this.marketingFee = void 0;
    this.municipality = void 0;
    this.place = void 0;
    this.placeDescription = void 0;
    this.marketOverviewEntry = void 0;
    this.phone = void 0;
    this.title = void 0;
    this.branch = void 0;
    this.updated = void 0;
  }

  public getMarketPlace() {
    let marketPlace = '';
    if (this.place !== '' || this.placeDescription !== '') {
      if (this.place === this.placeDescription) {
        marketPlace = this.place;
      } else {
        if (this.place !== '') {
          marketPlace += this.place;
        }
        if (this.place !== '' && this.placeDescription !== '') {
          marketPlace += ' - ';
        }
        if (this.placeDescription !== '') {
          marketPlace += this.placeDescription;
        }
      }
    }

    return marketPlace;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/market-accounting.model.ts